module.exports = __webpack_public_path__ + "img/preview-avatar.61a60ffe.svg";